import { Send, CheckCircle, XCircle } from 'lucide-vue-next';
import { isEmail, isPhoneNumber } from "@/utils/index";
// eslint-disable-next-line no-unused-vars
import CoreService from "@/services/core.service";
import { ElementType } from "@/types/FormTypes";
import { t } from "@/utils/lang.util";
// import debounce from 'lodash/debounce';
import { ref, computed } from 'vue';
export default {
    emits: ['submit', 'update:modelValue'],
    props: {
        modelValue: {
            required: true,
        },
        endpoint: {
            required: true
        },
        autoFocus: {
            default: false
        },
        metaData: {
            default: null
        }
    },
    components: {
        CheckCircle, Send, XCircle
    },
    // setup(props, { emit }) {
    data() {
        return {
            iconSize: 18
        };
    },
    setup(props, { emit }) {
        let submitting = ref(false);
        let submitted = ref(false);
        let submitError = ref(false);
        const fieldValues = ref({});
        // set default values (defaultValue)
        for (let i = 0; i < props.modelValue.elements.length; i++) {
            if (props.modelValue.elements[i]['defaultValue']) {
                // eslint-disable-next-line vue/no-setup-props-destructure
                fieldValues.value[props.modelValue.elements[i]['name']] = props.modelValue.elements[i]['defaultValue'];
            }
        }
        const isFormValid = computed(() => {
            let isValid = true; // or prove otherwise
            props.modelValue.elements.forEach(el => {
                const curVal = fieldValues.value[el.name];
                if (!validateField(el, curVal)) {
                    isValid = false;
                }
            });
            return isValid;
        });
        const requiresFocus = ((idx) => {
            // only first form elements receives focus, if autoFocus prop is set to true
            if (props.autoFocus && idx === 0)
                return true;
        });
        const getFieldStateClass = ((el, curVal) => {
            // set no class when field is not required and field is empty
            if (!el.required) {
                if (curVal) {
                    return 'form__field-input--success';
                }
                else {
                    return '';
                }
            }
            else {
                if (!validateField(el, curVal)) {
                    return 'form__field-input--error';
                }
                else {
                    return 'form__field-input--success';
                }
            }
        });
        const validateField = (el, curVal) => {
            let valid = true; // or prove otherwise
            // console.log(el, curVal)
            if (!el.required && !curVal) {
                valid = true;
            }
            else if ((!curVal && el.minLength) ||
                (curVal && curVal.length < el.minLength)) {
                valid = false;
            }
            else if (el.dataType === 'EMAIL' && !isEmail(curVal)) {
                valid = false;
            }
            else if (el.dataType === 'PHONE' && !isPhoneNumber(curVal)) {
                valid = false;
            }
            return valid;
        };
        const formSubmitted = async () => {
            submitting.value = true;
            setTimeout(async () => {
                try {
                    // append form type (PRE_CHAT, POST_CHAT etc) to the request body
                    const res = await CoreService.sendForm('post', props.endpoint, {
                        type: props.modelValue.type,
                        fields: fieldValues.value,
                        meta: props.metaData
                    });
                    // const res = {}
                    // delay(500).then(() => emit('success'))
                    emit('submit', { success: true, form: props.modelValue, data: res, fieldValues: fieldValues.value });
                }
                catch (e) {
                    submitError.value = true;
                    emit('submit', { success: false, form: props.modelValue, data: { error: e.message.toString() } });
                }
                finally {
                    submitting.value = false;
                    submitted.value = true;
                }
            }, 500);
        };
        const dismissBtnClicked = () => {
            emit('dismiss');
        };
        const inputType = (dataType) => {
            switch (dataType) {
                case 'EMAIL':
                    return 'email';
                case 'NUMBER':
                    return 'number';
                default:
                    return 'text';
            }
        };
        return {
            ElementType,
            validateField,
            fieldValues,
            submitting,
            submitted,
            submitError,
            formSubmitted,
            dismissBtnClicked,
            isFormValid,
            inputType,
            getFieldStateClass,
            requiresFocus,
            t
        };
    },
    methods: {
        isEmailValid(val) {
            return isEmail(val);
        },
        getPlaceholder(el) {
            return el.placeholder || this.$t(`forms.fields.${el.name}.placeholder`, ' ');
        },
        getLabel(el) {
            return el.label || this.$t(`forms.fields.${el.name}.label`, ' ');
        }
    },
    mounted() {
    }
};
